import { api } from './api/api';
import {
  MonitoringCardsResponse,
  MonitoringChartsResponse,
  MonitoringLocationFeatureCollection,
  MonitoringMetricsResponse,
  MonitoringQuery,
} from 'components/Monitoring/types';

export async function getMonitoringMetrics(params: MonitoringQuery, signal?: AbortSignal) {
  return api.get<MonitoringMetricsResponse>('/monitoramento/metricas/', {
    params,
    signal,
  });
}

export async function getMonitoringCards(params: MonitoringQuery, signal?: AbortSignal) {
  return api.get<MonitoringCardsResponse>('/monitoramento/metricas/cards/', {
    params,
    signal,
  });
}

export async function getMonitoringCharts(params: MonitoringQuery, signal?: AbortSignal) {
  return api.get<MonitoringChartsResponse>('/monitoramento/metricas/graficos/', {
    params,
    signal,
  });
}

export async function getMonitoringLocationPoints(
  params: Pick<MonitoringQuery, 'data_inicio' | 'data_fim'>,
  signal?: AbortSignal,
) {
  return api.get<MonitoringLocationFeatureCollection>('/monitoramento/metricas/pontos/', {
    params,
    signal,
  });
}
